import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import Strategies from "../Strategies";
import Initiatives from "../AdminInitiatives";
import Kpis from "../Kpis";
import Perspectives from "../Perspectives";
import Pillars from "../Pillars";
import Themes from "../Themes";
import Tree from "../UserManagement/Tree";
import NotificationsManagement from "../NotificationsManagement";
import Users from "../UserManagement/Users";
import Groups from "../UserManagement/Groups";
import KPIConfig from "../KPIConfig";
import SystemThreshold from "../SystemThreshold";
import WeightKPIs from "../WeightKPIs";
import StrategicObjective from "../StrategicObjective";
import StrategicSubObjective from "../StrategicSubObjective";
import DropDown from "../DropDown";
import ErrorBoundary from "../ErrorBoundary";
import Navigator from "../Navigator";

import { ReactComponent as StrategiesIcon } from "../../assets/images/strategy-map.svg";
import { ReactComponent as StrategicIcon } from "../../assets/images/sitemaps.svg";
import { ReactComponent as ObjectiveIcon } from "../../assets/images/objectives-icon.svg";
import { ReactComponent as SubObjectiveIcon } from "../../assets/images/sub-objectives-icon.svg";
import { ReactComponent as AdminNotification } from "../../assets/images/admin-noti.svg";
import { ReactComponent as KPISIcon } from "../../assets/images/kpi2.svg";
import { ReactComponent as WeightIcon } from "../../assets/images/goal.svg";
import { ReactComponent as UserManagementIcon } from "../../assets/images/user-management.svg";
import { ReactComponent as KpiConfig } from "../../assets/images/kpiConfig.svg";

const routes = [
  {
    path: "/administration/strategies",
    name: "common.strategies",
    key: "CA",
    showInNav: true,
    component: Strategies,
  },
  {
    path: "/administration/initiatives",
    name: "common.initiatives",
    key: "CA",
    showInNav: true,
    component: Initiatives,
  },
  {
    path: "/administration/strategic-themes",
    name: "common.themes",
    key: "CA",
    showInNav: true,
    component: Themes,
  },
  {
    path: "/administration/perspectives",
    name: "common.perspectives",
    key: "CA",
    showInNav: true,
    component: Perspectives,
  },
  {
    path: "/administration/pillars",
    name: "common.pillars",
    key: "CA",
    showInNav: true,
    component: Pillars,
  },
  {
    path: "/administration/strategic-objective",
    name: "common.strategic-objectives",
    key: "CA",
    showInNav: true,
    component: StrategicObjective,
  },
  {
    path: "/administration/kpis",
    name: "common.kpis",
    key: "CA",
    showInNav: true,
    component: Kpis,
  },
  {
    path: "/administration/kpi-type-configuration",
    name: "common.kpi-types",
    key: "CA",
    showInNav: true,
    component: KPIConfig,
  },
  {
    path: "/administration/weight",
    name: "common.kpis-weight",
    key: "CA",
    showInNav: true,
    component: WeightKPIs,
  },
  {
    path: "/administration/system-threshold",
    name: "common.system-thresholds",
    key: "CA",
    showInNav: true,
    component: SystemThreshold,
  },
  {
    name: "common.permissions",
    key: "CA",
    showInNav: true,
    subItems: [
      {
        name: "common.users",
        path: "/administration/user-management/users",
      },
      {
        name: "common.groups",
        path: "/administration/user-management/groups",
      },
      {
        name: "common.organizational-structure",
        path: "/administration/user-management/tree",
      },
    ],
  },
  {
    path: "/administration/user-management/tree",
    name: "Tree",
    key: "CA",
    component: Tree,
  },
  {
    path: "/administration/user-management/users",
    name: "users",
    key: "CA",
    component: Users,
  },
  {
    path: "/administration/user-management/groups",
    name: "Groups",
    key: "CA",
    component: Groups,
  },
  {
    path: "/administration/notifications",
    name: "common.notifications",
    key: "CA",
    showInNav: true,
    component: NotificationsManagement,
  },
];

function AdminLayout() {
  const [theme, language, allowedScreens] = useSelector((store) => [
    store.theme,
    store.language,
    store.user.user.screens,
  ]);

  return (
    <div className="app">
      <Navigator
        getNavigatorItems={() => {
          return routes.filter((item) => item?.showInNav);
        }}
      />
      <DropDown theme={theme} locale={language.locale} />
      <ErrorBoundary>
        <Switch>
          {routes.map(
            ({ path, name, component, key }) =>
              (allowedScreens.includes(key) || !key) &&
              path && (
                <Route
                  path={path}
                  name={name}
                  component={component}
                  key={name}
                />
              )
          )}

          <Redirect from="/" to="/administration/strategies" />
        </Switch>
      </ErrorBoundary>
    </div>
  );
}

export default AdminLayout;
